import { render, staticRenderFns } from "./receiveAccountEdit.vue?vue&type=template&id=a5c447c8&"
import script from "./receiveAccountEdit.vue?vue&type=script&lang=js&"
export * from "./receiveAccountEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports